export enum OrganizationId {
    '2195ed89-bd12-4e27-9bdf-d8fcd9b8f14d' = 1,
    'b8f77630-9666-4627-b234-f4a1b5329e17' = 2
  }
  